var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('VChip',{attrs:{"color":_vm.color,"text-color":"white","small":""}},[_vm._v(_vm._s(_vm.$t(`smoothrPay.status.${_vm.status}`)))])
}
var staticRenderFns = []

export { render, staticRenderFns }